import { useLocaleMapping } from "@/Composables/useLocaleMapping";

export const useMonetary = () => {
    const { mappedLocale } = useLocaleMapping();

    const formatCurrency = (
        amount,
        options = { currency: "EUR", style: "currency" }
    ) => {
        return new Intl.NumberFormat(mappedLocale.value, options)
            .format(amount)
            .replace("€", "€ ");
    };

    return {
        formatCurrency,
    };
};
